import { fetchUser } from "actions/user";
import RequireData from "hooks/RequireData";
import React from "react";
import { Link } from "react-router-dom";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import userSelector from "selectors/user";
import { centHundredthsToString } from "utils/moneyFormat";
import HomeCard from "./HomeCard";

const MoneyBalanceCard: React.FC = () => {
    const [user, status] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    const text = React.useMemo(() => {
        if (status === "error") {
            return "Error, please refresh to try again.";
        } else if (status === "none" && user) {
            return centHundredthsToString(user.money_balance_cent_hundredths);
        } else {
            return "Loading...";
        }
    }, [user, status]);

    return (
        <HomeCard>
            <h5 className="card-title">Money Balance</h5>
            <p>{text}</p>
            <Link to="/home/dashboard/balance/money" className="card-link">
                Manage Money
            </Link>
        </HomeCard>
    );
};

export default MoneyBalanceCard;
